import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Utgåvor", -1)
const _hoisted_2 = { class: "row mt-3 mb-3" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row mt-3 mb-3" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "table table-sm table-striped table-bordered" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Utgåva"),
    /*#__PURE__*/_createElementVNode("th", null, "Manusstopp"),
    /*#__PURE__*/_createElementVNode("th", null, "Sättning"),
    /*#__PURE__*/_createElementVNode("th", null, "Tryck"),
    /*#__PURE__*/_createElementVNode("th", null, "Utgivning"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_8 = { class: "btn-group" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-edit" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/mgmt/editions/edition",
          class: "btn btn-primary btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Lägg till utgåva")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editions, (edition, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(edition.editionName), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.toLocalDateString(edition.scriptDeadline)), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.toLocalDateString(edition.compotitionDate)), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.toLocalDateString(edition.printDate)), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.toLocalDateString(edition.publicationDate)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.editEdition(edition.editionId)),
                    class: "btn btn-sm btn-primary",
                    title: "Ändra utgåva"
                  }, _hoisted_11, 8, _hoisted_9),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.deleteEdition(edition.editionId)),
                    class: "btn btn-sm btn-danger",
                    title: "Ta bort utgåva"
                  }, _hoisted_14, 8, _hoisted_12)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}